import { BarChart } from "@mui/x-charts/BarChart";

export default function BasicBars({ apiData = [] }) {
  const currentMonth = new Date().toLocaleString("en-US", {
    month: "long",
  });

  const xAxisData = apiData.map((item) =>
    item.MonthName?.substring(0, 3)?.toUpperCase(),
  );

  const achievementData = apiData.map((item) => item.AchievementAmount);
  const pendingData = apiData.map((item) => item.PendingAmount);

  return (
    <div className="bg-white h-[300px] w-full rounded-3xl ">
      <BarChart
        xAxis={[
          {
            scaleType: "band",
            data: xAxisData,
          },
        ]}
        series={[
          {
            data: achievementData,
            label: "Achievement",
            stack: "total",
            color: "#16A34A",
            valueFormatter: (v) => ` ${v?.toLocaleString()}`,
          },
          {
            data: pendingData,
            label: "Pending",
            stack: "total",
            color: "#FE165A",
            valueFormatter: (v) => `${v?.toLocaleString()}`,
          },
        ]}
        slotProps={{
          bar: {
            rx: 6,
          },
        }}
        sx={{
          "& .MuiBarElement-root": {
            transition: "all 0.4s ease",
          },
          "& .MuiChartsAxis-tickLabel": {
            fontWeight: 500,
          },
        }}
        height={300}
      />
    </div>
  );
}
